<script setup>
import { formatCurrency, formatDecimals } from '@/helpers/stringHelpers'
import { defineProps } from 'vue'

defineProps({
  headers: {
    type: Array,
    default: () => []
  },
  items: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const sortby = 'weight'
const sortDesc = true
</script>

<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      dense
      item-key="id"
      :sort-by="sortby"
      :sort-desc="sortDesc"
      hide-default-footer
      disable-pagination
      class="elevation-1"
    >
      <template #[`item.weight`]="{ value }">
        {{ formatDecimals(value) }}
      </template>
      <template #[`item.price_kg`]="{ value }">
        {{ formatCurrency(value) }}
      </template>
      <template #[`item.line_total`]="{ item }">
        {{ formatCurrency(item.price) }}
      </template>
    </v-data-table>
  </div>
</template>
